{
  "appointment": {
    "CONFIRMATION_NUMBER": "No. Konfirmasi",
    "APPOINTMENT_ID": "ID Janji Temu",
    "APPOINTMENT_DATE": "Tanggal Janji Temu",
    "APPOINTMENT_TIME": "Waktu Janji Temu",
    "APPOINTMENT_TIMEZONE": "Zona Waktu",
    "APPOINTMENT_TYPE": "Jenis Janji Temu",
    "SCHEDULED_DURATION": "Durasi Terjadwal (menit)",
    "STATUS": "Status",
    "ARRIVAL_DATE": "Tanggal Kedatangan",
    "ARRIVAL_TIME": "Waktu Kedatangan",
    "DEPARTURE_DATE": "Tanggal Keberangkatan",
    "DEPARTURE_TIME": "Waktu Keberangkatan",
    "DWELL_TIME": "Waktu Tinggal (menit)",
    "ON_TIME": "Ketepatan Waktu (menit)",
    "IN_PROGRESS_DATE": "Tanggal Dalam Proses",
    "IN_PROGRESS_TIME": "Waktu Dalam Proses",
    "WAIT_TIME": "Waktu tunggu (menit)",
    "PROCESSING_TIME": "Waktu pemrosesan (menit)",
    "WAREHOUSE": "Gudang",
    "DOCK": "Dok",
    "LOAD_TYPE": "Jenis Muatan",
    "LOAD_TYPE_DIRECTION": "Arah",
    "RESCHEDULE_COUNT": "Jumlah Penjadwalan Ulang",
    "CREATED_BY": "Dibuat Oleh",
    "CREATOR_TYPE": "Jenis Pembuat",
    "CREATION_DATE": "Tanggal Pembuatan",
    "LAST_UPDATED_BY": "Terakhir Diperbarui Oleh",
    "LAST_UPDATE_DATE": "Tanggal Pembaruan Terakhir",
    "LAST_UPDATE_TIME": "Waktu Pembaruan Terakhir",
    "CARRIER_COMPANY": "Perusahaan Pengangkut",
    "CONTACT_NAME": "Nama Kontak",
    "CONTACT_EMAIL": "Email Kontak",
    "CONTACT_PHONE": "Telepon Kontak",
    "NOTES": "Catatan",
    "TAGS": "Tag",
    "CUSTOM_FIELDS": "Kolom Kustom",
    "EXTERNAL_VALIDATION_STATUS": "Status Validasi Eksternal",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "Pesan Kesalahan Validasi Eksternal",
    "CheckOut": "Check-out",
    "CheckInAdditionalAssetDetails": "Detail aset tambahan saat check-in",
    "InboundClaim": "Klaim Masuk",
    "OutboundClaim": "Klaim Keluar",
    "BookLoadType": "Jenis Muatan Pemesanan",
    "AssetContainerDetails": "Detail kontainer aset",
    "AppointmentCompleted": "Janji Temu Selesai"
  },
  "assetVisit": {
    "id": "ID Kunjungan",
    "appointmentId": "ID Janji Temu",
    "checkInDate": "Tanggal/Waktu Check-in",
    "checkOutDate": "Tanggal/Waktu Check-out",
    "carrier": "Pengangkut",
    "warehouseName": "Gudang",
    "currentStatus": "Status",
    "licensePlate": "Pelat Nomor",
    "visitType": "Jenis Kunjungan",
    "dotNumber": "Nomor DOT",
    "phone": "Telepon",
    "isPlanned": "Terencana",
    "driverNotes": "Catatan Pengemudi",
    "checkInAcknowledged": "Check-in Dikonfirmasi",
    "firstName": "Nama Depan Verifikasi ID",
    "lastName": "Nama Belakang Verifikasi ID",
    "birthdate": "Tanggal Lahir Verifikasi ID",
    "idValidationEmail": "Email Verifikasi ID",
    "idValidationPhone": "Telepon Verifikasi ID"
  }
}
